import Alpine from 'alpinejs';

Alpine.data('logo', () => ({
    is_hidden: false,
    lastScroll: 0, // store last scroll position
    threshold: 200, // scroll threshold in pixels

    init() {
        this.observeHide();
    },

    observeHide() {
        const footer = document.querySelector('footer');

        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;

            // Check if footer is in viewport
            if (footer) {
                const rect = footer.getBoundingClientRect();
                this.footerVisible = rect.top < window.innerHeight && rect.bottom > 0;
            }

            if (this.footerVisible) {
                this.is_hidden = true;
            } else if (currentScroll > this.threshold) {
                if (currentScroll > this.lastScroll) {
                    this.is_hidden = true;
                }
                else {
                    this.is_hidden = false;
                }
            } else {
                this.is_hidden = false;
            }

            this.lastScroll = currentScroll;
        });
    }
}));